import React, { useState, useEffect } from "react";
import "./navbar.css";
import Logo from "../../Assets/LogoBG.png";
import { Link } from "react-router-dom";
import FooterBtns from '../FooterBtns';
const Navbar = ({ title, ContactNumber }) => {
  const [click, setClick] = useState(false);
  const [hover, setHover] = useState(false);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToCars = () => {
    // Scroll to the car section when the "Cars" link is clicked
    const carSection = document.getElementById("carSection");
    carSection.scrollIntoView({ behavior: "smooth" });

    // if (click) {
    //   carSection.style.opacity = "1";
    // }
  };

  function handleClick() {
    if (click) {
      const carSection = document.getElementById("carSection");
      carSection.style.opacity = "1";
    }
  }

  function handleHover() {
    setHover(true);
  }


  const handleCarsClick = () => {
    if (window.location.pathname === "/about") {
      // Redirect to the cars section on the home page
      window.location.href = "/";
    } else {
      // Call the scrollToCars function for other pages
      scrollToCars();
    }
  };

  

  // const handleCarsClick = () => {
  //   scrollToCars();
  //   // setClick(true);
  // };

  return (
    <div>
      <main>
        <header>
          <div className="px-3 py-2 text-bg-dark border-bottom">
            <div className="container">
              <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                <a className="navbar-brand" href="#">
                  {/* {title} */}
                  <img className=" Logo" src={Logo} alt="" />
                </a>
                <a
                  href="/"
                  className="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-white text-decoration-none"
                ></a>

                <ul className="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">
                  <li className="align-items-center">
                    <a
                      href="/"
                      className={`nav-link Nav`}
                      onClick={handleHover}
                    >
                      {/* <> */}
                      Home
                    </a>
                  </li>
                  <li>
                    <Link to={"/about"} className="nav-link Nav">
                      
                      About
                    </Link>
                  </li>

                  <li>
                    {innerWidth < 427 ? (
                      <Link to={"/cars"} className="nav-link Nav">
                                              Cars
                      </Link>
                    ) : (
                      <Link
                        to={""}
                        className="nav-link Nav"
                        onClick={handleCarsClick}
                      >
                                              Cars
                      </Link>
                    )}
                  </li>
                  <li>
                    <a href="https://maps.app.goo.gl/ZNHZwW21KjHrrNteA" target="_blank" className="nav-link Nav">
                      
                      Location
                    </a>
                  </li>
                  {/* <li>
                    <a href="#" className="nav-link Nav">
                       Customers
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="px-3 py-2 border-bottom mb-3">
            <div className="container d-flex flex-wrap align-items-center justify-content-around">
              <span className="text-white SSDN">S.S.D.N</span>

              <div className="d-flex justify-content-center">
                 

                {
                  window.location.pathname==="/about" ? (
                     <FooterBtns/>
                  ): 
                  <button className="btn btn-warning contactBtn" type="submit">
                     Contact us <a style={{textDecoration:"none", color:"black"}} href="tel:9824345377">{ContactNumber}</a>
                  </button>
                }

              </div>
            </div>
          </div>
        </header>
      </main>
    </div>
  );
};

export default Navbar;
